import { useTranslation } from 'react-i18next';
import { useAuth } from '@/features/auth/useAuth';
import { useLiveVehicles } from '@/features/live/useLiveVehicles';
import { FleetSearch } from './FleetSearch';

/**
 * The Overview's fleet search, self-contained for the shell's top bar (canvas 1i
 * puts it beside the greeting and bell). It fetches the live vehicle list the
 * filter runs over — the SAME cache entry the Overview body uses (constant query
 * key), so mounting it here costs no extra request.
 *
 * Rendered by the shell ONLY on the Overview route, so no other route pays for the
 * live query. When the tenant has no vehicles there is nothing to search, so the
 * box is ABSENT rather than a control over an empty set.
 */
export function OverviewSearch() {
  const { t } = useTranslation();
  const { state } = useAuth();
  const tenantId = state.status === 'authenticated' ? state.user.tenantId : undefined;
  const query = useLiveVehicles({ tenantId });
  const vehicles = query.data?.vehicles ?? [];

  if (vehicles.length === 0) return null;
  return <FleetSearch vehicles={vehicles} t={t} />;
}
